import { Directive, OnDestroy, OnInit, ElementRef, Renderer2, Input } from '@angular/core';
import { ProgressService } from '../../services/progress/progress.service';
import { Subscription } from '../../../../../node_modules/rxjs';


@Directive({
    selector: '[inProgress]'
})
export class InProgressDirective implements OnInit, OnDestroy {

    private sub?: Subscription;

    @Input() public disableProgress?: boolean;

    constructor(
        private $progressService: ProgressService,
        private el: ElementRef,
        private renderer: Renderer2
    ) { }

    private b: any;

    ngOnInit() {
        this.sub = this.$progressService.getStateChange().subscribe(result => {
            if (this.disableProgress !== true) {
                if (result) {
                    if (result.inProgress === true) {
                        if (!this.el.nativeElement.style.position) {
                            this.el.nativeElement.style.position = 'relative';
                        }
                        if (!this.b) {
                            this.b = this.renderer.createElement('div');
                            this.renderer.addClass(this.b, 'in-prograss-curtain');

                            const bContent = this.renderer.createElement('div');
                            this.renderer.addClass(bContent, 'in-prograss-curtain-content');

                            this.renderer.appendChild(this.b, bContent);
                            this.renderer.appendChild(this.el.nativeElement, this.b);
                        }
                    } else {
                        if (this.b) {
                            this.renderer.removeChild(this.el.nativeElement, this.b);
                            this.b = null;
                        }
                    }
                }
            }
        });
    }
    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

}
